export const AUTH_KEY =  'NUCLEUS_APP_AUTH'